// https://tanstack.com/query/v4/docs/react/reference/useQuery

export default {
	cacheTime: 1000 * 60 * 60 * 24, // 1 day,
	staleTime: 1000 * 60 * 60 * 24, // 1 day,
	enabled: true,
	retryOnMount: true, // default: true
	refetchIntervalInBackground: false,
}